import React from "react";

import Main from "../layouts/Main";

import PageBanner from "../components/PageBanner";

const Services = () => (
  <Main>
    <PageBanner title="Prospective International Student" />
    <section className="ls s-py-60 s-py-md-90 s-py-xl-120 single-service  c-gutter-60">
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <article className="vertical-item content-padding type-event status-publish format-standard has-post-thumbnail">
            <div className="item-media">
                <img
                  src={`${process.env.PUBLIC_URL}/assets/images/jmty-event.jpg`}
                  alt=""
                />
              </div>
              <div className="item-content pl-0 pr-0 pb-0">
                <div className="entry-content">
                  <p className="excerpt">
                    Are you thinking about getting a U.S. degree but don’t know
                    how to go about it? Let us work with you through the entire
                    process.
                  </p>
                  <p className="excerpt">This service includes:</p>

                  <ul>
                    <li>Finding the school and program best suited for you</li>
                    <li>Essay / Personal Statement review</li>
                    <li>Scholarship/Funding search</li>
                    <li>
                      Custom timeline document to keep you on track and ensure
                      you meet application deadlines
                    </li>
                    <li>Visa Interview Preparation</li>
                    <li>Logistic services when you land in the U.S.</li>
                    <li>
                      Integrating you into our community of international
                      students when you arrive in the US.
                    </li>
                  </ul>
                </div>
                <br />
                <br />
                <a
                  href="https://docs.google.com/forms/d/e/1FAIpQLSdSxtJYcmf-c0ABnq7iXycpqx8KgaEiznxPr93axFI_u_VHqQ/viewform?vc=0&c=0&w=1&flr=0&gxids=7757"
                  target="_blank"
                  className="btn btn-small btn-maincolor"
                >
                  Schedule a Consultation
                </a>
              </div>
            </article>
          </div>
        </div>
      </div>
    </section>
  </Main>
);

export default Services;
